var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullseye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5C8.75 2.92969 7.07031 1.25 5 1.25C2.92969 1.25 1.25 2.92969 1.25 5C1.25 7.07031 2.92969 8.75 5 8.75C7.07031 8.75 8.75 7.07031 8.75 5ZM10 5C10 7.76172 7.76172 10 5 10C2.23828 10 0 7.76172 0 5C0 2.23828 2.23828 0 5 0C7.76172 0 10 2.23828 10 5ZM5 6.5625C5.86328 6.5625 6.5625 5.86328 6.5625 5C6.5625 4.13672 5.86328 3.4375 5 3.4375C4.13672 3.4375 3.4375 4.13672 3.4375 5C3.4375 5.86328 4.13672 6.5625 5 6.5625ZM5 7.8125C3.44727 7.8125 2.1875 6.55273 2.1875 5C2.1875 3.44727 3.44727 2.1875 5 2.1875C6.55273 2.1875 7.8125 3.44727 7.8125 5C7.8125 6.55273 6.55273 7.8125 5 7.8125ZM5.625 5C5.625 5.3457 5.3457 5.625 5 5.625C4.6543 5.625 4.375 5.3457 4.375 5C4.375 4.6543 4.6543 4.375 5 4.375C5.3457 4.375 5.625 4.6543 5.625 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.5a4beea3656bf71a65b012d3afd814a7.svg";
export { ForwardRef as ReactComponent };